import { z } from 'zod';

import { zodDate, zodTime } from '../../utils/zodHelpers';
import { addressSchema } from './addresses';

export const nameAndCodeSchema = z.object({
    code: z.string(),
    name: z.string(),
});
export type NameAndCode = z.infer<typeof nameAndCodeSchema>;

export const dropReasonSchema = nameAndCodeSchema;

export const prioritySchema = nameAndCodeSchema.extend({ order: z.number(), color: z.string() });

export const languageSchema = nameAndCodeSchema;

export const sexSchema = nameAndCodeSchema;
export type Sex = z.infer<typeof sexSchema>;

export const _uuidAndNameSchema = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
});

export const organizationBasicSchema = _uuidAndNameSchema;

export type OrganizationBasic = z.infer<typeof organizationBasicSchema>;

export const patientBasicSchema = _uuidAndNameSchema.extend({
    dob: zodDate(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
});
export type PatientBasic = z.infer<typeof patientBasicSchema>;

export const territorySimple = _uuidAndNameSchema.extend({
    organization: organizationBasicSchema,
});
export type TerritorySimple = z.infer<typeof territorySimple>;

export const serviceAreaBasicSchema = _uuidAndNameSchema.extend({
    organization: organizationBasicSchema,
});
export type ServiceAreaBasic = z.infer<typeof serviceAreaBasicSchema>;

export const qhpTeamBasicSchema = _uuidAndNameSchema.extend({
    name: z.string(),
    organization: organizationBasicSchema,
});
export type QhpTeamBasic = z.infer<typeof qhpTeamBasicSchema>;

export const qhpTeamForListSchema = qhpTeamBasicSchema.extend({
    timezones: z.array(z.string()),
});
export type QhpTeamForList = z.infer<typeof qhpTeamForListSchema>;

export const qhpSimpleSchema = _uuidAndNameSchema.extend({
    logo_url: z.string().url().nullable(),
    timezone: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    teams: z.array(qhpTeamBasicSchema),
    address: addressSchema.nullable(),
});
export type QhpSimple = z.infer<typeof qhpSimpleSchema>;

export const patientSimpleSchema = _uuidAndNameSchema.extend({
    care_team: z.array(qhpSimpleSchema).nullish(),
});
export type PatientSimple = z.infer<typeof patientSimpleSchema>;

export const qhpTeamDetailSchema = qhpTeamBasicSchema.extend({
    organization: organizationBasicSchema,
    qhps: z.array(qhpSimpleSchema),
});
export type QhpTeamDetail = z.infer<typeof qhpTeamDetailSchema>;

export const dayOfWeekHoursSchema = z.object({
    // Use ISO 8601 day of week, 1 = Monday, 7 = Sunday
    day_of_week: z.number(),
    start_time: zodTime(),
    end_time: zodTime(),
});
export type DayOfWeekTimeslot = z.infer<typeof dayOfWeekHoursSchema>;
